import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Navigation from '../components/Navigation';
import { Link, useNavigate } from 'react-router-dom';
import { listAccounts } from '../actions/accountActions';

const DetailsPage: React.FC = () => {
  const userLogin = useSelector((state: appState) => state.userLogin);
  const { userData } = userLogin;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!userData) {
      navigate('/');
    }

    dispatch(listAccounts());
  }, [dispatch, navigate, userData]);

  const accountsList = useSelector((state: appState) => state.accountsList);
  const { loading, error, accounts } = accountsList;

  return (
    <div className='account-page'>
      <Navigation />
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className='error'>{error}</p>
      ) : (
        <div className='account-main'>
          <h1>Your Accounts</h1>
          <div className='account-list'>
            {accounts.map((account) => (
              <div key={account.id} className='account-item'>
                <p>Account Number: {account.number}</p>
                <p>Account Type: {account.type}</p>
                <p>Date Opened: {account.created_at}</p>
                <p>
                  Account Status:{' '}
                  {account.balance >= 0 ? 'Good' : 'Overdrafted'}
                </p>
              </div>
            ))}
          </div>
          <Link to={'/open'} className='open-btn'>
            Open New Account
          </Link>
        </div>
      )}
    </div>
  );
};

export default DetailsPage;
